/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Save file" |
*
* @param {Chat_Blob_Save_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_title = /** @type {((inputs?: Chat_Blob_Save_Dialog_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei speichern")
	return /** @type {LocalizedString} */ ("Save file")
});